type QueryParams = Record<string, string | undefined>

export const useQueryParams = <T extends QueryParams>(
  paramNames: (keyof T)[]
): T => {
  const queryParams = new URLSearchParams(window.location.search)

  const values: Partial<T> = {}

  paramNames.forEach((paramName) => {
    const paramValue = queryParams.get(paramName as string)

    if (paramValue !== null && paramValue !== undefined) {
      values[paramName] = paramValue as T[keyof T]
    }
  })

  return values as T
}
